/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/typings.d.ts" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: "typings.d",
      ext: "ts",
      content:
        "declare module '*.css';\ndeclare module '*.less';\ndeclare module '*.png';\ndeclare module '*.svg' {\n  export function ReactComponent(\n    props: React.SVGProps<SVGSVGElement>,\n  ): React.ReactElement;\n  const url: string;\n  export default url;\n}\n",
    },
  ];
}
